import { EventListeners, MinzeElement, Reactive } from 'minze'
import { Font } from '../../../constants'

export interface LvcDrawerModal {
  modalId: string
  modalStatus: string
  modalTitle: string
  titleSize: string
}

export class LvcDrawerModal extends MinzeElement {
  attrs = ['modal-id', 'modal-title', 'no-close-button', 'close']
  static observedAttributes = ['close']
  _authHandler: any = null

  onCloseButtonClick() {
    this.closeModal()
  }

  onOverlayClick() {
    this.closeModal()
  }

  closeModal() {
    this.cast('close')
    this.remove()
  }

  onAttributeChange(name: string, oldValue: string, newValue: string) {
    if (name === 'close' && newValue === 'true') {
      this.closeModal()
    }
  }

  html = () => `
   <div id="lvc-modal-overlay" class="lvc-modal-overlay">
    </div>
    <div id="lvc-modal" class="lvc-modal">
      <div class="container">
        <div class="header">
          ${(this.modalTitle && `<div class="title">${this.modalTitle}</div>`) || ''}
          ${this.noCloseButton ? '' : `<div id="lvc-close-button"><lvc-circle-close-icon></lvc-circle-close-icon></div>`}
        </div>
        <div class="content">
          <slot></slot>
        </div>
      </div>
    </div>
  `

  css = () => {
    return `
    :host {
      z-index: 100000;
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      width: 100%;
      height: 100%;
      display: block;
    }
      
    #lvc-close-button {
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }

    .lvc-modal {
      /* right side drawer */
      position: fixed;
      right: 0;
      top: 0;
      max-width: 447px;
      width: 100%;
      height: 100%;
      bottom: 0;
      background: #fff;
      padding: 0px;
    }
    
    .container {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      max-height: 100%;
      position: relative;
      padding: 42px;
      overflow: hidden;
      box-sizing: border-box;
    }

    .header {
      flex: 1;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 0px;
      width: 100%;
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
      position: relative;
    }

    .content {
      flex: 1;
      width: 100%;
      height: 100%;
      order: 1;
      align-self: stretch;
      overflow: auto;
    }
    
     .title {
      font-family: ${Font.family};
      font-weight: ${Font.weight.extraBold};
      line-height: 120%;
      color: #1E007D;
      flex: none;
      width: 88%; /*so text wraps properly*/
      order: 0;
      flex-grow: 0;
      color: var(--brand-minuit, #1E007D);
      font-variant-numeric: lining-nums tabular-nums;
      font-feature-settings: 'clig' off, 'liga' off;
      font-size: 40px;
      font-style: normal;
    }

    .lvc-modal-overlay {
      position: fixed; /* Stay in place */
      left: 0;
      top: 0;
      width: 100%; /* Full width */
      height: 100%; /* Full height */
      overflow: auto; /* Enable scroll if needed */
      background-color: rgba(0,0,0,0.25);
      cursor: pointer;
    }

    @media (max-width: 447px) {
      .lvc-modal {
        max-width: 100%;
      }
      .header {
        min-width: 0px;
      }
      .title {
        font-size: 24px;
      }
    }
   


  `
  }

  eventListeners: EventListeners = [
    ['#lvc-modal-overlay', 'click', this.onOverlayClick.bind(this)],
    ['#lvc-close-button', 'click', this.onCloseButtonClick.bind(this)],
  ]
}
